import { useLoadImage, uuid } from '@repo-level/core-front';
import type { BackgroundConfig } from 'contexts/background';
import { BackgroundContext } from 'contexts/background';

import { useMedia } from 'modules/common/hooks/useMedia';
import type { FC } from 'react';
import { useContext, useMemo } from 'react';

import { ScBackground } from './styled';

export const Background = () => {
  const { backgroundConfig } = useContext(BackgroundContext);

  const [config, key] = useMemo(
    () => [backgroundConfig, uuid()],
    [backgroundConfig]
  );

  return config ? <BackgroundInner key={key} {...config} /> : null;
};

const BackgroundInner: FC<BackgroundConfig> = ({
  deskImage,
  mobImage,
  deskPositionX = 'left',
  mobSize,
  deskSize,
  mobPositionX = 'center',
}) => {
  const { isMobileS } = useMedia();
  const currentImage = useMemo(
    () => (isMobileS && mobImage ? mobImage : deskImage),
    [deskImage, isMobileS, mobImage]
  );

  const { loadedImage, loading } = useLoadImage(currentImage);

  return (
    <ScBackground
      $image={loadedImage}
      $loading={loading}
      deskPositionX={deskPositionX}
      deskSize={deskSize}
      mobPositionX={mobPositionX}
      mobSize={mobSize}
    >
      <div />
    </ScBackground>
  );
};
